import { Combobox as HeadlessCombobox } from '@headlessui/react';
import { type ReactElement } from 'react';

type ComboboxBaseProperties<T> = {
  readonly children: {
    title?: ReactElement;
    leadingIcon?: ReactElement;
    input?: ReactElement;
    dropDownButton?: ReactElement;
    options?: ReactElement;
    error?: ReactElement;
  };
  readonly value: T;
  readonly className?: string;
  readonly name?: string;
  readonly disabled?: boolean;
  readonly onBlur?: () => void;
  readonly onChange?: (value: T | null) => void;
  readonly multiple?: boolean;
};

export function ComboboxBase<T>({
  value,
  children,
  className,
  disabled,
  name,
  onBlur,
  onChange,
  multiple,
}: ComboboxBaseProperties<T>) {
  return (
    <HeadlessCombobox
      as="div"
      value={value}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any -- headlessui's conditional onChange type can't be narrowed when `multiple` is dynamic
      onChange={onChange as any}
      className={className}
      disabled={!!disabled}
      name={name}
      multiple={multiple}
      onBlur={onBlur}
    >
      {children.title}
      <div className="relative w-full">
        {children.leadingIcon}
        {children.input}
        {children.dropDownButton}
        {children.options}
      </div>
      {children.error}
    </HeadlessCombobox>
  );
}
